import { AvatarCustom } from "..";
import { ICommonWPClass } from "../../services/get-alerts/get-alerts.interface";
import React from "react";


  interface IWellnessRenewalPetAvatars {
    petDetails: ICommonWPClass[];
    defaultWellnessStatus?: boolean;
    defaultOverdueStatus?: boolean;
    className?: string
    height?: number;
    width?: number;
}

const WellnessRenewalPetAvatars = ({
  petDetails,
  className,
  height=70,
  width=70,
  defaultWellnessStatus = false,
  defaultOverdueStatus = false,
}: IWellnessRenewalPetAvatars) => {
  return (
    <div className={`flex ${className}`} >
      {petDetails.map((petDetail: ICommonWPClass, index: number) => (
        <div key={index} className={`
        rounded-full -ml-4 ${index === 0 ? "ml-0" : ""}`} style={{ zIndex: petDetails.length - index }}>
          <AvatarCustom
            width={width}
            height={height}
            image={petDetail?.petImage ?? undefined}
            name={petDetail?.petName}
            isWellnessMember={defaultWellnessStatus ? defaultWellnessStatus : false}
            isPlanOverdue={defaultOverdueStatus && defaultOverdueStatus}
            isBorder="white"
          />
        </div>
      ))}
    </div>
  );
};

export default WellnessRenewalPetAvatars;
